{
  "name": "evs",
  "version": "1.155.6",
  "author": "EVS Auto-Ecole",
  "homepage": "https://www.envoituresimone.com/",
  "packageManager": "npm@11.9.0",
  "scripts": {
    "ng": "ng",
    "start": "ionic cordova run browser",
    "start:devstage": "ionic serve --configuration=devstage",
    "config": "node configs/setenv.js",
    "build": "BUILD_ENV=${BUILD_ENV:-dev} ng build --configuration=$BUILD_ENV",
    "test": "ng test",
    "lint": "ng lint",
    "prettier": "prettier . --write",
    "prettier-check": "prettier . --check",
    "heroku-postbuild": "BUILD_CONFIGURATION=${BUILD_CONFIGURATION:-production} npm run prettier-check && npm run config && ionic build --configuration=$BUILD_CONFIGURATION --release --no-interactive --confirm",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org app36782511herokucom --project evs-app ./www && sentry-cli sourcemaps upload --org app36782511herokucom --project evs-app ./www",
    "type-check:strict": "tsc -p src/tsconfig-strict.app.json --noEmit",
    "test:e2e": "npx playwright test --config=e2e/playwright.config.ts",
    "test:e2e:ui": "npx playwright test --config=e2e/playwright.config.ts --ui",
    "test:e2e:headed": "npx playwright test --config=e2e/playwright.config.ts --headed",
    "test:visual": "npx playwright test --config=e2e/visual/playwright.visual.config.ts",
    "test:visual:update": "npx playwright test --config=e2e/visual/playwright.visual.config.ts --update-snapshots",
    "test:visual:report": "npx playwright show-report e2e/visual/playwright-report",
    "postinstall": "patch-package",
    "prepare": "husky"
  },
  "engines": {
    "node": "24"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/platform-browser": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@awesome-cordova-plugins/adjust": "6.6.0",
    "@awesome-cordova-plugins/camera": "6.6.0",
    "@awesome-cordova-plugins/core": "6.6.0",
    "@awesome-cordova-plugins/deeplinks": "6.6.0",
    "@awesome-cordova-plugins/device": "6.6.0",
    "@awesome-cordova-plugins/diagnostic": "^6.16.0",
    "@awesome-cordova-plugins/file": "6.6.0",
    "@awesome-cordova-plugins/file-transfer": "6.6.0",
    "@awesome-cordova-plugins/in-app-browser": "6.6.0",
    "@awesome-cordova-plugins/ionic-webview": "6.6.0",
    "@awesome-cordova-plugins/launch-review": "6.6.0",
    "@awesome-cordova-plugins/market": "6.6.0",
    "@awesome-cordova-plugins/splash-screen": "6.6.0",
    "@awesome-cordova-plugins/status-bar": "6.6.0",
    "@checkout.com/checkout-web-components": "^1.7.1",
    "@en-voiture-simone/evs-kit": "^1.45.0",
    "@en-voiture-simone/seemone": "^0.0.71",
    "@googlemaps/markerclusterer": "^2.6.2",
    "@ionic/angular": "^8.0.0",
    "@ionic/storage-angular": "^4.0.0",
    "@kameleoon/javascript-sdk": "^4.17.1",
    "@lottiefiles/lottie-player": "^1.5.7",
    "@ng-select/ng-select": "^21.0.0",
    "@sentry/angular": "^10.17.0",
    "@typeform/embed": "^4.10.0",
    "angular-google-tag-manager": "^1.11.0",
    "com.adjust.sdk": "^4.38.1",
    "cordova-launch-review": "^4.1.3",
    "cordova-plugin-androidx-adapter": "^1.1.3",
    "cordova-plugin-calendar": "^5.1.6",
    "cordova-plugin-camera": "^8.0.0",
    "cordova-plugin-device": "^2.0.3",
    "cordova-plugin-file": "^8.0.0",
    "cordova-plugin-file-transfer": "^1.7.1",
    "cordova-plugin-geolocation": "^5.0.0",
    "cordova-plugin-inappbrowser": "^6.0.0",
    "cordova-plugin-market": "^1.2.0",
    "cordova-plugin-marketingcloudsdk": "^8.1.1",
    "cordova-plugin-statusbar": "^2.4.3",
    "cordova-sqlite-storage": "^7.0.0",
    "cordova-support-android-plugin": "^1.0.1",
    "cordova-support-google-services": "^1.3.2",
    "cordova.plugins.diagnostic": "^7.2.8",
    "express": "^4.17.1",
    "ionic-plugin-deeplinks": "^1.0.20",
    "jssha": "^2.3.1",
    "mailcheck": "^1.1.1",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.44",
    "primeng": "21.1.3",
    "rxjs": "^7.8.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular-devkit/core": "^21.0.4",
    "@angular-devkit/schematics": "^21.0.4",
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler": "^21.0.6",
    "@angular/compiler-cli": "^21.0.6",
    "@angular/language-service": "^21.0.6",
    "@commitlint/cli": "^20.5.0",
    "@commitlint/config-conventional": "^20.5.0",
    "@ionic/angular-toolkit": "^12.0.0",
    "@ionic/cli": "^7.2.0",
    "@ionic/cordova-builders": "^12.3.0",
    "@playwright/test": "^1.58.2",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^12.0.6",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/cordova": "11.0.3",
    "@types/google-maps": "^3.2.2",
    "@types/jssha": "^2.0.0",
    "@types/uuid": "^10.0.0",
    "autoprefixer": "^10.4.21",
    "cordova": "12.0.0",
    "cordova-android": "^14.0.1",
    "cordova-browser": "7.0.0",
    "cordova-ios": "7.1.1",
    "cordova-plugin-ionic-webview": "^5.0.1",
    "cordova-res": "^0.15.4",
    "handlebars": "^4.5.3",
    "husky": "^9.1.7",
    "jsdom": "^27.4.0",
    "lint-staged": "^16.2.7",
    "native-run": "^2.0.3",
    "patch-package": "^8.0.1",
    "plist": "^3.0.5",
    "postcss": "^8.5.3",
    "prettier": "^3.7.4",
    "semantic-release": "^25.0.3",
    "tailwindcss": "^4.2.1",
    "typescript": "~5.9.3",
    "vitest": "^4.0.17"
  },
  "overrides": {
    "angular-google-tag-manager": {
      "@angular/common": "^21.0.4",
      "@angular/compiler": "^21.0.4"
    }
  },
  "lint-staged": {
    "*.{js,ts,css,md,html}": "prettier --write"
  },
  "description": "An Ionic project",
  "cordova": {
    "plugins": {
      "cordova-plugin-ionic-webview": {
        "ANDROID_SUPPORT_ANNOTATIONS_VERSION": "27.+"
      },
      "cordova-plugin-inappbrowser": {},
      "cordova-plugin-androidx-adapter": {},
      "cordova-plugin-file": {
        "ANDROIDX_WEBKIT_VERSION": "1.4.0"
      },
      "cordova-plugin-file-transfer": {},
      "cordova-plugin-device": {},
      "cordova-sqlite-storage": {},
      "cordova-plugin-statusbar": {},
      "cordova-plugin-camera": {
        "ANDROID_SUPPORT_V4_VERSION": "27.+",
        "ANDROIDX_CORE_VERSION": "1.6.+"
      },
      "ionic-plugin-deeplinks": {
        "URL_SCHEME": "evs",
        "DEEPLINK_HOST": "*.envoituresimone.com",
        "DEEPLINK_SCHEME": "https",
        "ANDROID_PATH_PREFIX": "/ul/",
        "ANDROID_2_PATH_PREFIX": "/ul/",
        "ANDROID_3_PATH_PREFIX": "/ul/",
        "ANDROID_4_PATH_PREFIX": "/ul/",
        "ANDROID_5_PATH_PREFIX": "/ul/",
        "DEEPLINK_2_SCHEME": "https",
        "DEEPLINK_2_HOST": "*.envoituresimone.com",
        "DEEPLINK_3_SCHEME": "https",
        "DEEPLINK_3_HOST": "*.envoituresimone.com",
        "DEEPLINK_4_SCHEME": "https",
        "DEEPLINK_4_HOST": "*.envoituresimone.com",
        "DEEPLINK_5_SCHEME": "https",
        "DEEPLINK_5_HOST": "*.envoituresimone.com"
      },
      "cordova-plugin-market": {},
      "cordova-launch-review": {},
      "com.adjust.sdk": {},
      "cordova-plugin-geolocation": {
        "GEOLOCATION_USAGE_DESCRIPTION": "Retrouve nos enseignants au point de rendez-vous le plus proche, partout en France.",
        "GPS_REQUIRED": "true"
      },
      "cordova-plugin-marketingcloudsdk": {},
      "cordova.plugins.diagnostic": {
        "ANDROIDX_VERSION": "1.0.0",
        "ANDROIDX_APPCOMPAT_VERSION": "1.3.1"
      },
      "cordova-plugin-calendar": {
        "CALENDAR_USAGE_DESCRIPTION": " ",
        "CONTACTS_USAGE_DESCRIPTION": " "
      }
    },
    "platforms": [
      "browser",
      "android",
      "ios"
    ]
  }
}
